module.exports = __webpack_public_path__ + "img/gui_jiaoguan.38622042.png";